import React, { Component } from "react"
import Button from "../button-v2/button"
import * as Icon from "react-feather"
import CalendlyFormV2 from "../calendly-form-v2"

class CalendlyOverlay extends Component {
  state = {
    showModal: false,
  }
  toggleModal = (event) => {
    const { showModal } = this.state
    this.setState({
      showModal: !showModal,
    })
    document.body.classList.toggle("g--no-scroll-v2")
  }
  render() {
    const { showModal } = this.state
    return (
      <>
        {this.props.calendly_url && (
          <>
            <div
              className={`calendly-overlay ${
                showModal ? " calendly-overlay--visible" : ""
              }`}
            >
              {showModal && (
                <>
                  <div
                    onClick={this.toggleModal}
                    className="calendly-overlay__hack"
                  ></div>
                  <div
                    className="calendly-overlay__close"
                    onKeyDown={this.toggleModal}
                    onClick={this.toggleModal}
                  >
                    {Icon["X"] &&
                      React.createElement(Icon["X"], {
                        className: "icon icon--sm",
                      })}
                  </div>
                </>
              )}
              {showModal && (
                <div className="calendly-overlay__card s">
                  <CalendlyFormV2 calendly_link={this.props.calendly_url} />
                </div>
              )}
              <div
                className="calendly-overlay__background"
                onClick={this.toggleModal}
                onKeyDown={this.toggleModal}
              ></div>
            </div>
            <Button
              onClick={this.toggleModal}
              className={this.props.className}
              label={this.props.label}
              accessibilityLabel={this.props.accessibilityLabel}
              icon={this.props.icon}
              variant={this.props.variant}
              spacing={this.props.spacing}
            />
          </>
        )}
      </>
    )
  }
}

export default CalendlyOverlay
